import PaymentApi from '../../rest-api/payment-api';
import subscriptionPlans from '../authenticated/settings/subscriptionPlans.js';

//TODO in future we should avoid to call this 4 times (for every plan in subscriptionPlans)
// and let's modify that to keep it somewhere.
// other solution can be to keep couponId in one place, not in every plan
// but possible on plan will be more advertise etc
// TO remember: the text annualDiscountText from config.js is independent from discount
const getDiscountByPlan = async (bearerToken, planType) => {
    const planDetails = subscriptionPlans[planType];
    if (!planDetails || !planDetails.couponId) {
        console.warn(`No coupon ID found for plan: ${planType}`);
        return 0; // Default discount
    }

    try {
        console.log(`Fetching discount for Coupon ID: ${planDetails.couponId}`);

        // allow to work with out authToken for unauthenticated flow
        const token = bearerToken || process.env.REACT_APP_PUBLIC_API_KEY;

        const response = await PaymentApi.getDiscountByCouponId(token, planDetails.couponId);

        console.log('Discount API Response:', response);

        if (response.statusCode === 200 && response.coupon?.percent_off) {
            console.warn(`Coupon ID discount: ${response.coupon.percent_off}`);
            return response.coupon.percent_off;
        }
    } catch (error) {
        console.error('Error fetching discount:', error);
    }

    return 0; // Return 0% discount if failed
};

export default getDiscountByPlan;
